/**
 * Volume Distribution Calculator
 *
 * Process overlap and cycle-event lookup helpers for VolumeDistribution UI.
 */

/**
 * Check if process has overlap with interval.
 * Supports multiple process events (e.g. Sort 0 + main cycle windows).
 * Returns { startsAfter, endsBefore, hasOverlap } for the first overlapping window.
 */
export const getProcessOverlapInfo = (processEvents, interval) => {
  const events = Array.isArray(processEvents) ? processEvents : processEvents ? [processEvents] : [];
  if (!events.length || !interval) {
    return { startsAfter: false, endsBefore: false, hasOverlap: false };
  }

  for (const event of events) {
    const processStart = event.timeIntervals[0].startTime;
    const processEnd = event.timeIntervals[0].endTime;
    const overlapStart = Math.max(processStart, interval.startTime);
    const overlapEnd = Math.min(processEnd, interval.endTime);
    if (overlapStart < overlapEnd) {
      const startsAfter = processStart > interval.startTime;
      const endsBefore = processEnd < interval.endTime;
      return { startsAfter, endsBefore, hasOverlap: true };
    }
  }
  return { startsAfter: false, endsBefore: false, hasOverlap: false };
};

/**
 * Get all cycle events for a process (returns array for Sort 0 sites with multiple windows)
 */
export const getCycleEvents = (cycleName, process, opsClock) => {
  return opsClock.clockEvents.filter((e) => e.process === process && e.cycleName === cycleName);
};
